import { Button, makeStyles } from '@rneui/themed'
import React, { useRef } from 'react'
import { Platform, useWindowDimensions, View } from 'react-native'
import {
  Menu,
  MenuOption,
  MenuOptions,
  MenuTrigger,
  renderers,
} from 'react-native-popup-menu'
import { WEB_SCREEN_WIDTH } from 'shared/constants'

interface Props {
  message?: string
}

const InfoPopup = ({ message }: Props) => {
  const ref = useRef<Menu>(null)
  const { width: w } = useWindowDimensions()
  let width = w
  if (Platform.OS === 'web') {
    width = w > WEB_SCREEN_WIDTH ? WEB_SCREEN_WIDTH : w
  }

  const styles = useStyles()
  return (
    <View style={styles.container}>
      <Menu
        ref={ref}
        renderer={renderers.Popover}
        rendererProps={{
          placement: 'bottom',
          anchorStyle: styles.anchorStyle,
        }}
      >
        <MenuTrigger>
          <Button
            icon={{
              name: 'info',
              color: styles.button.color,
              containerStyle: styles.buttonContainer,
            }}
            onPress={async () => {
              await ref.current?.open()
            }}
            buttonStyle={styles.button}
          />
        </MenuTrigger>
        <MenuOptions
          customStyles={{ optionsWrapper: { width: width * 0.7 } }}
          optionsContainerStyle={{ width: width * 0.7 }}
        >
          <MenuOption text={message} />
        </MenuOptions>
      </Menu>
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 5,
  },
  buttonContainer: { margin: 0, padding: 0 },
  button: {
    margin: 0,
    padding: 0,
    marginHorizontal: 0,
    paddingHorizontal: 0,
    backgroundColor: 'transparent',
    color: theme.colors.grey2,
  },
  anchorStyle: {
    width: 0,
    height: 0,
  },
}))

export default InfoPopup
